import { createContext, useContext } from 'react';
export const OnboardingContext = createContext(null);
const execute = (_feature, action) => action();
export function useFeatureIntroduction() {
  return useContext(OnboardingContext)?.introduce || execute;
}
export function useGuidedOnboarding() { return useContext(OnboardingContext); }
